<template>
  <div class="release-arrive">
    <div style="margin-top: -30px">
      <icon-title
        title="发布推文"
        :img-src="require('@/assets/home/admin/home/text_title.png')"
      />

      <div>
        <custom-form
          :labelPosition="'top'"
          ref="customFormRef"
          :form-items="formItems"
          :initial-form-data="initialFormData"
          :form-rules="formRules"
          :show-cancel-btn="true"
          :show-confirm-btn="true"
          :isShowList="['取消', '确认']"
          confirm-btn-type="success"
          :button-group-style="{ marginTop: '30px', textAlign: 'center' }"
          @confirm="handleFormConfirm"
          @cancel="handleFormCancel"
          @upload-success="handleUploadSuccess"
        >
          <template>
            <div style="margin-top: 10px; display: flex; align-items: center">
              <i class="el-icon-warning f15"></i>
              <p style="padding-left: 10px" class="f12">
                订阅号每年最多发365次推文。服务号每年最多48次，每月4次
              </p>
            </div>
          </template>
        </custom-form>
      </div>
    </div>
  </div>
</template>
<script>
// 引入文章表格的列配置
import {
  articleTableHeaders,
  dialogTableHeaders,
  actionButtons,
  formItems,
} from "@/utils/defaultData";
export default {
  name: "ArticleReleaseArrive",
  props: {
    tableData: Array,
  },
  data() {
    return {
      publishLoading: false,
      dialogTableHeader: dialogTableHeaders, // 发布弹窗表格列配置
      dialogTableLoading: false,
      dialogPagination: {
        total: 10,
        currentPage: 1,
        pageSize: 10,
      },
      // 表单配置项（按需配置不同类型的控件）
      formItems: formItems.articleFormItems,
      // 表单初始值
      initialFormData: {
        // 推文属于哪个tap
        username: "",
        //上传封面
        uploadList: [],
        //摘要
        remark: "",
        // 发布至
        releaseTo: 1,
        //留言
        leaveMessage: 1, //留言 初始为关闭状态（对应 inactiveValue: 0）
        //  通知 
        notice: 1, //  通知 初始为关闭状态（对应 inactiveValue: 0）
      },
      // 表单校验规则
      formRules: {
        // username: [
        //   { required: true, message: "请输入用户名", trigger: "blur" },
        //   {
        //     min: 2,
        //     max: 10,
        //     message: "用户名长度在2-10个字符",
        //     trigger: "blur",
        //   },
        // ],
        username: [
          { required: true, message: "请选择所属tap", trigger: "change" },
        ],
      },
    };
  },
  created() {
    // 互殴
  },
  mounted() {
    // 初始化获取文章分类
    this.getArticleCategoryList();
  },
  watch: {},
  methods: {
    // 获取文章所有分类
    getArticleCategoryList() {
      this.$api.admin.article.getArticleCategoryAPI().then((res) => {
        if (res.code === 200) {
          formItems.articleFormItems[0].options = res.data.map((item) => ({
            label: item.categoryName,
            value: item.categoryId,
          }));
          console.log("获取文章所有分类", res, formItems);

        }
      });
    },
    // 切换位置功能（根据当前位置自动执行上移或下移）
    togglePosition(index, type) {
      if (this.dialogTableData.length <= 1) return;

      const newData = [...this.dialogTableData];

      // 如果是第一行，执行下移
      if (index === 0 || type === "bottom") {
        // 与下一行交换位置
        const temp = newData[index];
        newData[index] = newData[index + 1];
        newData[index + 1] = temp;
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行下移`);
      }
      // 如果是最后一行，执行上移
      else if (index === this.dialogTableData.length - 1 || type === "top") {
        // 与上一行交换位置
        const temp = newData[index];
        newData[index] = newData[index - 1];
        newData[index - 1] = temp;
        this.dialogTableData = newData;
        this.$message.success(`已将第${index + 1}行上移`);
      }
    },
    // 表单确认提交
    handleFormConfirm(formData) {
      console.log("表单提交数据：", formData);
      this.$emit("confirm", formData);
      
    },
    // 表单取消/重置
    handleFormCancel() {
      this.$emit("cancel", null);
    },
    // 上传成功回调
    handleUploadSuccess({ res, file, uploadedFiles }) {
      console.log(
        `ArticleReleaseArrive父组件上传${uploadedFiles}成功：`,
        res,
        file,
        uploadedFiles,
      );
      this.$message.success("文件上传成功");
    },
    handlePublishConfirm() {
      this.publishLoading = true;
     
    },
  },
};
</script>
<style scoped lang="scss">
.release-arrive {
  padding: 20px;
}
</style>
